import { createSelector } from 'reselect'

const selectFaq = state => state.faq

const selectQuestions = createSelector(selectFaq, faq => faq.questions)

const selectLandingCategories = createSelector(
  selectFaq,
  faq => faq.landingCategories
)

const selectFaqFetching = createSelector(selectFaq, faq => faq.isFetching)

const selectFaqFetchingLanding = createSelector(
  selectFaq,
  faq => faq.isFetchingLanding
)

const selectCurrentPhoneFaqId = createSelector(
  selectFaq,
  faq => faq.currentPhoneId
)

const selectActiveFAQ = createSelector(selectFaq, faq => faq.activeFAQ)

export {
  selectQuestions,
  selectLandingCategories,
  selectFaqFetching,
  selectFaqFetchingLanding,
  selectCurrentPhoneFaqId,
  selectActiveFAQ
}



// WEBPACK FOOTER //
// ./src/containers/FAQs/selectors.js